import axios from 'axios';

const DEG_PER_MS = 360 / 32000;
const RETURN_DURATION = 900;

function initRotation(card) {
   const svg = card.querySelector('svg');
   let angle = 0;
   let rafId = null;
   let lastTime = null;

   card.addEventListener('mouseenter', () => {
      svg.style.transition = 'none';
      lastTime = null;

      function tick(t) {
         if (lastTime !== null) angle += DEG_PER_MS * (t - lastTime);
         lastTime = t;
         svg.style.transform = `rotate(${angle}deg)`;
         rafId = requestAnimationFrame(tick);
      }
      rafId = requestAnimationFrame(tick);
   });

   card.addEventListener('mouseleave', () => {
      cancelAnimationFrame(rafId);
      angle = angle % 360;
      const target = angle > 180 ? 360 : 0;
      svg.style.transition = 'none';
      svg.style.transform = `rotate(${angle}deg)`;
      requestAnimationFrame(() => {
         requestAnimationFrame(() => {
            svg.style.transition = `transform ${RETURN_DURATION}ms ease-out`;
            svg.style.transform = `rotate(${target}deg)`;
         });
      });
      setTimeout(() => { angle = 0; }, RETURN_DURATION);
   });
}

export function initTeamModal() {
   const cards = [...document.querySelectorAll('.team-card')];
   if (!cards.length) return;

   cards.forEach(initRotation);

   // Build overlay
   const overlay = document.createElement('div');
   overlay.className = 'team-overlay';
   overlay.innerHTML = `
      <button class="team-overlay__close" aria-label="Close">×</button>
      <div class="team-overlay__inner">
         <div class="team-overlay__body"></div>
      </div>
   `;
   document.body.appendChild(overlay);

   const closeBtn = overlay.querySelector('.team-overlay__close');
   const bodyEl = overlay.querySelector('.team-overlay__body');
   let originX = '50%';
   let originY = '50%';

   function open(card) {
      const rect = card.getBoundingClientRect();
      originX = `${(rect.left + rect.width / 2).toFixed(1)}px`;
      originY = `${(rect.top + rect.height / 2).toFixed(1)}px`;

      overlay.style.transition = 'none';
      overlay.style.clipPath = `circle(0px at ${originX} ${originY})`;
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      bodyEl.innerHTML = '';

      requestAnimationFrame(() => {
         requestAnimationFrame(() => {
            overlay.style.transition = 'clip-path 0.65s cubic-bezier(0.4, 0, 0.2, 1)';
            overlay.style.clipPath = `circle(200vmax at ${originX} ${originY})`;
         });
      });

      const data = new FormData();
      data.append('action', 'ajax_get_team_member');
      data.append('postID', card.dataset.postId);

      axios.post(settings.ajaxurl, data).then(response => {
         bodyEl.innerHTML = response.data.html;
         setTimeout(() => overlay.classList.add('content-visible'), 350);
      });
   }

   function close() {
      overlay.classList.remove('content-visible');
      setTimeout(() => {
         overlay.style.transition = 'clip-path 0.55s cubic-bezier(0.4, 0, 0.2, 1)';
         overlay.style.clipPath = `circle(0px at ${originX} ${originY})`;
         overlay.scrollTop = 0;
         setTimeout(() => {
            overlay.classList.remove('is-open');
            document.body.style.overflow = '';
         }, 560);
      }, 200);
   }

   cards.forEach(card => card.addEventListener('click', () => open(card)));
   closeBtn.addEventListener('click', close);
   document.addEventListener('keydown', e => {
      if (overlay.classList.contains('is-open') && e.key === 'Escape') close();
   });
}
